module.exports = __webpack_public_path__ + "static/melo-interpolation-d07c6d67c98df43777f32e5053d4b29d.gif";